import { render, staticRenderFns } from "./BatchPage.vue?vue&type=template&id=5b03dfaa"
import script from "./BatchPage.vue?vue&type=script&lang=js"
export * from "./BatchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports